// Libarary
import { Injectable } from '@angular/core';

// Service
import { ConfigService } from '../infrastructure/config.service';
import { NetworkService } from '../infrastructure/network.service';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class CppService {
  public redirectFrom: any;
  public redirectFromSra: any;

  constructor(public configService: ConfigService,
    private networkService: NetworkService) {
    this.cppOrderId = new BehaviorSubject(0);
  }
  webOrderNumberAndSplitId: any;
  cppOrderId: BehaviorSubject<number>;
  shouldShowSurveyMessage: boolean;
  evolveSurveyUrl: string;

  public setCppOrderId(value: number) {
    this.cppOrderId.next(value);
  }
  //
  public setRedirectionFrom(value) {
    this.redirectFrom = value;
  }
  // Get Cpp Item Number List
  public getCppItemNumberList(blnAllItems?: boolean) {
    if (blnAllItems && blnAllItems == true) {
      // This will pull data where IsCPP=N,Y (For COI)
      return this.networkService.getRequest(this.configService.getCppItemNumberDataWithCPP_N());
    }
    else {
      return this.networkService.getRequest(this.configService.getCppItemNumberData());
    }
  }

  //CppParentItemNumberList
  public getCppParentItemNumberList() {
    return this.networkService.getRequest(this.configService.getCppParentItemNumberList());
  }

  //Get Disclaimer Message
  public GetDisclaimerMessage() {
    return this.networkService.getRequest(this.configService.GetDisclaimerMessage());
  }

    // Get Cpp Item Master Details
  public getCppItemMasterDetails(isCppPage) {

    return this.networkService.getRequest(this.configService.getCppItemMasterDetailsData() + '?isCPPPage=' + isCppPage);
  }


  // Get All Cpp Item List for Add Product Slider
  public getAllCppItemList(filters) {
    return this.networkService.postRequest(this.configService.getAllCppItemListData(), filters);
  }

  // Delete an item from the CPP cart
  public deleteFromCart(shipToId: number) {
    return this.networkService.postRequest(this.configService.deleteFromCartData(), shipToId);
  }

  // Get Cpp Order Items List
  public cppOrderItemsList(filters) {
    return this.networkService.postRequest(this.configService.getCppOrderItemsData(), filters);
  }

  // Get Cpp Error Orders List
  public getCppErrorOrdersList(filters) {
    return this.networkService.postRequest(this.configService.getCppErrorOrdersData(), filters);
  }

  // Get Cpp Ship To Facility List
  public getShipToFacilityList() {
    return this.networkService.getRequest(this.configService.getCppShipToFacilityData());
  }

  // Get Cpp Deliver To Facility List
  public getDeliverToFacilityList(accountNumber, shipToAccountParentNumber) {
    return this.networkService.getRequest(this.configService.getCppDeliverToFacilityData() + '?accountNumber=' + accountNumber + '&shipToAccountParentNumber=' + shipToAccountParentNumber);
  }

  // Get Cpp Sold To Facility
  public getSoldToFacility(accountNumber) {
    return this.networkService.getRequest(this.configService.getCppSoldToFacilityData() + '?accountNumber=' + accountNumber);
  }

  // Get Cpp order detail
  public getCppOrderDetail(webOrderNumber, splitId) {
    return this.networkService.getRequest(this.configService.getCppOrderDetailData() + '?webOrderNumber=' + webOrderNumber + '&splitId=' + splitId);
  }

  // Get Cpp Edit order detail
  public getCppEditOrderDetail(orderId) {
    return this.networkService.getRequest(this.configService.getCppEditOrderDetailData() + '?orderId=' + orderId);
  }

  // Check for existing Draft Order
  public checkExistingDraftOrder(accountNumber) {
    return this.networkService.getRequest(this.configService.checkExistingDraftOrder() + '?accountNumber=' + accountNumber);
  }

  // Save Create Order
  public saveOrder(saveObj) {
    return this.networkService.postRequest(this.configService.saveOrder(), saveObj);
  }

  // Place Order
  public placeOrder(saveObj) {
    return this.networkService.postRequest(this.configService.placeOrder(), saveObj);
  }

  // Resubmit order
  resubmitOrder(saveObj) {
    return this.networkService.postRequest(this.configService.resubmitOrder(), saveObj);
  }

  // Delete order Items
  deleteOrderItems(saveObj) {
    return this.networkService.postRequest(this.configService.deleteOrderItems(), saveObj);
  }

  // Resubmit orders list data
  resubmitOrdersList(resubmitObj) {
    return this.networkService.postRequest(this.configService.resubmitOrdersList(), resubmitObj);
  }

  // Get CPP Instruction type list
  public getCPPInstructionTypeList() {
    return this.networkService.getRequest(this.configService.getCPPInstructionTypeList());
  }

  // set favorite
  public saveProductForfavorite(productId, isFavorite) {
    return this.networkService.getRequest(this.configService.setFavorite() + '?productId=' + productId + '&isFavorite=' + isFavorite);
  }
  // Delete Order
  public deleteCppOrder(orderId) {
    return this.networkService.postRequest(this.configService.deleteCppOrder(), orderId);
  }

  // Get Order Summary data
  public getOrderSummaryDetails(webOrderNumber) {
    return this.networkService.getRequest(this.configService.getOrderSummaryDetails() + '?webOrderNumber=' + webOrderNumber);
  }

  // send CPP Order Confirmation Email
  public sendCPPOrderConfirmationEmail(emailObject) {
    return this.networkService.postRequest(this.configService.sendCPPOrderConfirmationEmail(), emailObject);
  }

  // Get Cpp excel report
  public getCPPReport(filters) {
    return this.networkService.postRequest(this.configService.getCPPReport(), filters);
  }

  // Get account SDM
  public getAccountSDMReasonCodeData(accountNumber) {
    return this.networkService.getRequest(this.configService.getAccountSDMReasonCodeData() + '?accountNumber=' + accountNumber);
  }

  // Get items SDM
  public getItemsSDM(itemIds: string, accountNumber: number, isCustomerPickup, shipToAccount: number) {
    return this.networkService.getRequest(this.configService.getItemsSDM() + '?itemIds=' + itemIds + '&accountNumber='
      + accountNumber + '&isCustomerPickup=' + isCustomerPickup + '&shipToAccount=' + shipToAccount);
  }

  // pdf from base64 date
  public sendBaseDate(filters) {
    return this.networkService.postRequest(this.configService.postFileForPdf(), filters);
  }

  // get cpp bulk contact detail
  public getCPPDeliveryInstruction(accountNumber) {
    return this.networkService.getRequest(this.configService.getCPPDeliveryInstructions() + '?accountNumber=' + accountNumber);
  }

  // get cpp order detail
  public getCppShipToOrderDetail(accountNumber, parentAccountNumber, cppOrderId) {
    return this.networkService.getRequest(this.configService.getCppShipToOrderDetail() + '?accountNumber=' + accountNumber + '&parentAccountNumber=' + parentAccountNumber + '&cppOrderId=' + cppOrderId);
  }

  // get marketing program list view data
  public getMarketingProgramSummary(filters) {
    return this.networkService.postRequest(this.configService.getMarketingProgramSummaryDataUrl, filters);
  }

  // get marketing program tile view data
  public getMarketingProgramTileViewSummary(filters) {
    return this.networkService.postRequest(this.configService.getMarketingProgramTileDataUrl, filters);
  }

  // toggle marketing program item favorite
  public toggleFavoriteItem(itemId) {
    return this.networkService.postRequest(this.configService.toggleFavoriteItemUrl, itemId);
  }

  // toggle marketing program manufacturer favorite
  public toggleFavoriteManufacturerUrl(marketingBrandId: string) {
    return this.networkService.getRequest(this.configService.toggleFavoriteManufacturerUrl + '?marketingBrandId=' + marketingBrandId);
  }

  // toggle marketing program filter data
  public getFilterMasterData() {
    return this.networkService.getRequest(this.configService.getFilterMasterDataUrl);
  }

  // toggle marketing program filter data
  public downloadProgramFile(mediaObjectId) {
    return this.networkService.getRequest(this.configService.downloadProgramFileDataUrl + '?mediaObjectId=' + mediaObjectId);
  }

}
